/**
 * CV Health visuals: shared by the onboarding report and the editor sheet.
 * Components resolve to their `.tsx` (iOS + Android) or `.web.tsx` twin at
 * bundle time; both twins take the props declared in `health-props.ts`.
 */
export { HealthRings } from './HealthRings';
export { HealthHeart } from './HealthHeart';
export { HealthStatusLine } from './HealthStatusLine';
export { HealthFindingRow } from './HealthFindingRow';
export { HealthProposalReview } from './HealthProposalReview';
export { HealthReportHeader } from './HealthReportHeader';
export { HealthAreaIcon } from './HealthAreaIcon';
export { HealthDisclosure } from './HealthDisclosure';
export { HealthScoreGauge } from './HealthScoreGauge';
export { HealthScoreCard } from './HealthScoreCard';
export { HealthCheckedAreas } from './HealthCheckedAreas';
export { HealthSuggestionList } from './HealthSuggestionList';
export { HealthAreaReport } from './HealthAreaReport';
export { HealthChangeReview } from './HealthChangeReview';
export { HealthCheckProgress } from './HealthCheckProgress';
export { HealthAgentStatus } from './HealthAgentStatus';

export type {
  HealthAreaReportProps,
  HealthCardAction,
  HealthChangeReviewItem,
  HealthChangeReviewProps,
  HealthCheckedAreasProps,
  HealthCheckProgressProps,
  HealthDisclosureProps,
  HealthScoreCardProps,
  HealthScoreGaugeProps,
  HealthSuggestionListProps,
  HealthFindingActionProps,
  HealthFindingRowProps,
  HealthAgentStatusProps,
  HealthHeartProps,
  HealthProposalReviewProps,
  HealthReportHeaderProps,
  HealthRingsProps,
  HealthStatusLineProps,
} from './health-props';

export * from './cv-health-copy';
export * from './health-rings-geometry';
export * from './health-gauge-geometry';
export * from './health-heart-path';
